// extracted by mini-css-extract-plugin
export default {"cardBody":"_-_-record-it-components-src-card-CardBody-__cardBody"};